// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-col">
                        <div className="logo">
                            <span className="logo-text">WadeBros</span>
                            <span className="logo-subtext">Auto Detailing</span>
                        </div>
                        <p className="footer-text">
                            Premium auto detailing services with a commitment to excellence and customer satisfaction.
                        </p>
                    </div>

                    <div className="footer-col">
                        <h3 className="footer-title">Quick Links</h3>
                        <ul className="footer-links">
                            <li><a href="#services">Services</a></li>
                            <li><a href="#gallery">Gallery</a></li>
                            <li><a href="#about">About Us</a></li>
                            <li><a href="#testimonials">Testimonials</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h3 className="footer-title">Services</h3>
                        <ul className="footer-links">
                            <li><a href="/">Basic Wash & Wax</a></li>
                            <li><a href="/">Interior Detailing</a></li>
                            <li><a href="/">Full Detail Package</a></li>
                            <li><a href="/">Ceramic Coating</a></li>
                            <li><a href="/">Paint Correction</a></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h3 className="footer-title">Newsletter</h3>
                        <p className="footer-text">
                            Subscribe to get special offers and detailing tips.
                        </p>
                        <form className="newsletter-form">
                            <input type="email" placeholder="Your Email" />
                            <button type="submit">Subscribe</button>
                        </form>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p className="copyright">
                        &copy; {new Date().getFullYear()} WadeBros Auto Detailing. All rights reserved.
                    </p>
                    <div className="legal-links">
                        <a href="/">Privacy Policy</a>
                        <a href="/">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;